import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';
import { BllOrtak } from '../../providers/bll/bll-ortak';
import { Ortak } from '../../providers/ortak';
import { CalendarComponentOptions } from 'ion2-calendar';

/**
 * Generated class for the KasaHareketDetayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kasa-hareket-detay',
  templateUrl: 'kasa-hareket-detay.html',
})
export class KasaHareketDetayPage {
  vwHareket: any = {};
  hareket: any = {};
  kasahareket: any = { KasaID: "", Sign: "", CardRef: "", Tutar: "", SlsMan: "", Text: "", AciklamaRef: 1 };
  KasaListesi = [];
  islemyapan = this.ortak.aktifKullaniciAdi;
  aranan = "";
  skip: number = 0;
  take: number = 100;
  cari: any = {};
  baslangic:any;
  bitis:any;

  options: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
 
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("vwHareket") != null) {
      this.vwHareket = navParams.get("vwHareket");
      var data = new FormData();

      data.append("hareket_id", this.vwHareket.ID);
      this.bllOrtak.islem(data, "CariKasaHareketiGetirById", "", false).then(a => {
        var Sonuc = <any>a;
        this.hareket = Sonuc.SonucObject;
     
       
      }
      )
    }
    this.kasalar();
  }


  kapat() {
    this.viewCtrl.dismiss();
  }
  onChange($event)
  {this.hareket.IslemTarihi=this.ortak.tarih($event);
   
  }
  kasalar() {

    this.bllOrtak.islemWithoutPost("Kasalar", "", false).then(a => {
      var sonuc = <any>a;
     
      this.KasaListesi = sonuc.SonucObject;
      console.log("kasalar", this.KasaListesi );
    })
  }
   
  kaydet() {
    var formData = new FormData();
    
    console.log("haretket",this.hareket);
    formData.append("CariTah_json", JSON.stringify(this.hareket));
    this.bllOrtak.islem(formData, "CariKasaDekont", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();

    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/kasa-hareket-detay/kasa-hareket-detay.ts